"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function initModel(id, user, type) {
    var model = {
        id: null,
        channel_id: user.channel.id,
        name: '',
        label: '',
        description: '',
        short: '',
        hidden: false,
        position: null,
        sport_id: '',
        icon: '',
        logo: '',
        banner: '',
        watermark: '',
        team_id: '',
        options: {
            playout: '',
            livestreams_rtmp_max: '',
            livestreams_hls_max: '',
            billing_from: '',
        },
        type: ''
    };
    if (type.name === 'player') {
        model.type = type.name;
        model.user_id = user.id;
        model.role = user.role;
        model.sport_id = user.channel.sport_id;
    }
    else {
        model.type_id = '';
    }
    return model;
}
var mapping = {
    type_id: 'type.id',
    type: 'type.name',
    sport_id: 'sport.id',
    icon: 'options.icon',
    banner: 'options.banner',
    logo: 'options.logo',
    watermark: 'options.watermark',
};
function Save(_a) {
    var user = _a.user, id = _a.id;
    var type = user.role === 'coach' ? {
        label: 'Speler',
        url: 'spelers',
        name: 'player',
    } : {
        label: 'Kanaal',
        url: 'kanalen',
        name: 'channel',
    };
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    var params = {
        id: id,
        channel_id: user.channel.id,
        details: true,
    };
    var _c = storybook_1.Helpers.useSave('backend', 'channels', initModel(id, user, type), params, mapping), channel = _c[0], setChannel = _c[1], saveChannel = _c[2];
    var _d = react_1.useState(''), name = _d[0], setName = _d[1];
    react_1.useEffect(function () {
        if (name !== '' && name !== channel.data.name) {
            setChannel({ name: name });
            setName('');
        }
    }, [name]);
    function onSubmit(values, disableAlert) {
        return saveChannel(values).then(function (response) {
            if (response.errors.length) {
                return response;
            }
            if (!disableAlert) {
                var modalMessage_1 = id ? 'Je kanaal is succesvol opgeslagen' : 'Je kanaal is succesvol aangemaakt';
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: modalMessage_1, returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels", onClose: id ? function () {
                            setName(response.data.name);
                            closeModal();
                        } : null }); }
                });
            }
            return response;
        });
    }
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (id && !channel.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.ContainerWithSidebar, null,
                react_1.default.createElement(storybook_1.Layouts.Main, null,
                    react_1.default.createElement(storybook_1.Channels.Form, { type: type, user: user, channel: channel, setChannel: setChannel, saveChannel: saveChannel, submit: onSubmit })),
                react_1.default.createElement(storybook_1.Layouts.Sidebar, null)))));
}
exports.Save = Save;
Save.defaultProps = {
    id: null,
};
